import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { BaseMachine } from "abreact/incubator/ui/machine/BaseMachine";
import { RemoteError } from "abweb/dto/exception/RemoteError";
import * as AbWebResources from "abweb/generated/locale/AbWebResources";
import { computed, observable, makeObservable } from "mobx";
export let RemoteErrorRendererMachine = (_class = class RemoteErrorRendererMachine extends BaseMachine {
  constructor(error, timestamp) {
    super();
    _initializerDefineProperty(this, "_error", _descriptor, this);
    _defineProperty(this, "_timestamp", void 0);
    makeObservable(this);
    this._error = error;
    this._timestamp = timestamp;
  }
  get timestamp() {
    return this._timestamp;
  }
  get message() {
    let value = this._error.message;
    if (this._error.remoteException) {
      if (this._error.remoteException.remoteNestedErrors) {
        value = this._error.remoteException.remoteNestedErrors.reduce((s, ex) => s + "\n" + ex.message, value);
      }
    }
    return value;
  }
  get title() {
    if (this._error.name) {
      return this._error.name;
    }
    return AbWebResources.fallbackErrorTitle();
  }
  get stackTrace() {
    if (this._error.remoteException && this._error.remoteException.remoteStackTrace) {
      return this._error.remoteException.remoteStackTrace;
    }
    return null;
  }
  get causedBy() {
    let value = [];
    if (this._error.causedBy) {
      value.push(this._error.causedBy);
    }
    if (this._error.remoteException) {
      if (this._error.remoteException.remoteCause) {
        value.push(new RemoteError(this._error.remoteException.remoteCause.message, null, null, this._error.remoteException.remoteCause));
      }
      if (this._error.remoteException.remoteNestedErrors) {
        this._error.remoteException.remoteNestedErrors.forEach(ex => {
          value.push(new RemoteError(ex.message, null, null, ex));
        });
      }
    }
    if (value.length > 0) {
      return value;
    }
    return null;
  }
  get showCausedBy() {
    return false;
  }
  get remoteException() {
    return this._error.remoteException;
  }
  getSupportDetailsText() {
    if (!this._error.remoteException) {
      return null;
    }
    let text = `${AbReactResources.remoteError_code()} ${this._error.remoteException.messageCode ? this._error.remoteException.messageCode : ""}`;
    text += `\n${AbReactResources.remoteError_messageArgs()}`;
    if (this._error.remoteException.messageArgs) {
      text += "\n";
      text += this._error.remoteException.messageArgs.map((arg, index) => `  ${index}: ${arg}`).join("\n");
    }
    return text;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_error", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "message", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "message"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "title", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "title"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stackTrace", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "stackTrace"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "causedBy", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "causedBy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remoteException", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "remoteException"), _class.prototype), _class);
//# sourceMappingURL=RemoteErrorRendererMachine.js.map
